/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import RefreshButton from './ui/RefreshButton';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Badge } from './ui/badge';
import { Textarea } from './ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogFooter } from './ui/dialog';
import { Switch } from './ui/switch';
import {
  Coins, Package, Gift, Clock, Zap, Users, TrendingUp, TrendingDown,
  Plus, Edit, Trash2, Eye, Search, Filter, Download, RefreshCw,
  UserPlus, Cake, Award, ShoppingCart, FileText, Key, AlertTriangle,
  CheckCircle, XCircle, Calendar, Timer, Percent, Hash, ArrowUpRight,
  ArrowDownRight, BarChart3, PieChart, Activity, Settings, Star, CreditCard,
  HelpCircle, BookOpen
} from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';
import StripeCheckoutButton from './StripeCheckoutButton';
import Sparkline from './credits/Sparkline';
import CreditUsagePlansTab from './CreditUsagePlansTab';
import CreditStatsAdvancedTab from './CreditStatsAdvancedTab';
import CreditAlertsAdminTab from './CreditAlertsAdminTab';


export const GCPackModal = ({ ctx }) => {
  const {
    actions, activeTab, attributeForm, attributeSearch, bonusForm, bonusRules,
    bulkAttributeForm, creditTypes, duplicateRaison, duplicateSource, duplicateTargetSearch,
    duplicateTargetUserId, editForm, editTarget, editingBonus, editingPack, loading,
    packForm, packs, searchTerm, selectedUserIds, showAttributeModal, showBonusModal,
    showBulkAttributeModal, showDuplicateModal, showEditModal, showPackModal, sparkSeries, stats,
    transactions, userBalances,
    setActions, setActiveTab, setAttributeForm, setAttributeSearch, setBonusForm, setBonusRules,
    setBulkAttributeForm, setCreditTypes, setDuplicateRaison, setDuplicateSource, setDuplicateTargetSearch,
    setDuplicateTargetUserId, setEditForm, setEditTarget, setEditingBonus, setEditingPack,
    setLoading, setPackForm, setPacks, setSearchTerm, setSelectedUserIds, setShowAttributeModal,
    setShowBonusModal, setShowBulkAttributeModal, setShowDuplicateModal, setShowEditModal, setShowPackModal,
    setSparkSeries, setStats, setTransactions, setUserBalances,
    exportUsersCsv, filteredUsers, handleAttributeCredits, handleBulkAttribute, handleBulkDelete,
    handleConfirmDuplicate, handleDeletePack, handleDeleteUserCredits, handleExportFiltered,
    handleExportSelection, handleSaveBonus, handleSaveEdit, handleSavePack, loadData, openDuplicateModal,
    openEditModal, renderIcon, resetPackForm, toggleSelectAllFiltered, toggleUserSelection,
    getAuthHeader, CountdownWidget, StatsCard, COLORS, AVAILABLE_ICONS,
  } = ctx;
  return (
      <Dialog open={showPackModal} onOpenChange={setShowPackModal}>
        <DialogContent className="max-w-2xl">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Package className="w-5 h-5 text-amber-500" />
              {editingPack ? 'Modifier le pack' : 'Créer un nouveau pack'}
            </DialogTitle>
          </DialogHeader>
          
          <div className="grid grid-cols-2 gap-4">
            <div className="col-span-2">
              <Label>Nom du pack *</Label>
              <Input
                value={packForm.nom}
                onChange={(e) => setPackForm({...packForm, nom: e.target.value})}
                placeholder="Ex: Pack Découverte"
              />
            </div>
            
            <div className="col-span-2">
              <Label>Description</Label>
              <Textarea
                value={packForm.description}
                onChange={(e) => setPackForm({...packForm, description: e.target.value})}
                placeholder="Description du pack..."
              />
            </div>

            <div>
              <Label>Crédits inclus *</Label>
              <Input
                type="number"
                min="1"
                value={packForm.credits_inclus}
                onChange={(e) => setPackForm({...packForm, credits_inclus: parseInt(e.target.value) || 0})}
              />
            </div>

            <div>
              <Label>Prix (€) *</Label>
              <Input
                type="number"
                min="0"
                step="0.01"
                value={packForm.prix_ht}
                onChange={(e) => setPackForm({...packForm, prix_ht: parseFloat(e.target.value) || 0})}
              />
            </div>

            <div>
              <Label className="flex items-center gap-2">
                <Gift className="w-4 h-4 text-green-500" />
                Bonus en unités
              </Label>
              <Input
                type="number"
                min="0"
                value={packForm.credits_bonus}
                onChange={(e) => setPackForm({...packForm, credits_bonus: parseInt(e.target.value) || 0})}
              />
            </div>

            <div>
              <Label className="flex items-center gap-2">
                <Percent className="w-4 h-4 text-green-500" />
                Bonus en %
              </Label>
              <Input
                type="number"
                min="0"
                max="100"
                value={packForm.bonus_pourcentage}
                onChange={(e) => setPackForm({...packForm, bonus_pourcentage: parseFloat(e.target.value) || 0})}
              />
            </div>

            <div>
              <Label>Icône</Label>
              <Select value={packForm.icone} onValueChange={(v) => setPackForm({...packForm, icone: v})}>
                <SelectTrigger>
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  {AVAILABLE_ICONS.map((icon) => (
                    <SelectItem key={icon.name} value={icon.name}>
                      <div className="flex items-center gap-2">
                        <icon.icon className="w-4 h-4" />
                        {icon.name}
                      </div>
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>

            <div>
              <Label>Couleur</Label>
              <Select value={packForm.couleur} onValueChange={(v) => setPackForm({...packForm, couleur: v})}>
                <SelectTrigger>
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  {COLORS.map((color) => (
                    <SelectItem key={color.value} value={color.value}>
                      <div className="flex items-center gap-2">
                        <div className="w-4 h-4 rounded" style={{ backgroundColor: color.value }} />
                        {color.name}
                      </div>
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>

            <div className="col-span-2 flex items-center gap-4">
              <div className="flex items-center gap-2">
                <Switch
                  checked={packForm.populaire}
                  onCheckedChange={(v) => setPackForm({...packForm, populaire: v})}
                />
                <Label>Pack populaire (badge ⭐)</Label>
              </div>
            </div>

            {/* Aperçu */}
            <div className="col-span-2 p-4 bg-gray-50 rounded-lg">
              <p className="text-sm text-gray-500 mb-2">Aperçu:</p>
              <div className="flex items-center gap-4">
                <div className="p-3 rounded-xl" style={{ backgroundColor: packForm.couleur }}>
                  {renderIcon(packForm.icone, "w-6 h-6 text-white")}
                </div>
                <div>
                  <p className="font-bold">{packForm.nom || 'Nom du pack'}</p>
                  <p className="text-sm text-gray-500">
                    {packForm.credits_inclus + packForm.credits_bonus + Math.floor(packForm.credits_inclus * packForm.bonus_pourcentage / 100)} crédits • {(packForm.prix_ht * 1.20).toFixed(2)} € Global
                  </p>
                </div>
              </div>
            </div>
          </div>

          <DialogFooter>
            <Button variant="outline" onClick={() => setShowPackModal(false)}>Annuler</Button>
            <Button onClick={handleSavePack} className="bg-amber-500 hover:bg-amber-600">
              {editingPack ? 'Mettre à jour' : 'Créer le pack'}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
  );
};

export default GCPackModal;
